import React, { Component } from 'react'

// HOW THIS WORKS

// `scripts` is a template tag. It processes a template literal
// and returns an InjectedScript component. The template literal contains
// the actual script code to be injencted and the InjectedScript component
// handles injecting it. The `script` template literal will not return
// an InjectedScript component if there are undefined values being interpolated.
// This means the script will not be injected until all the values are ready.
// The InjectedScript only injects the script once. This means that it will wait
// until all the needed values are present, and then only inject the script once.

// Example:

//   script`console.log("I got ${undefined}")` === null
//   script`console.log("I got ${'foo'}")`     === <InjectedScript code={`console.log("I got foo")`} />

function hasUndefined(arr) {
  return arr.findIndex(x => x === undefined) >= 0
}

function script(strs, ...vals) {
  if (hasUndefined(vals)) {
    return null
  }
  const code = strs.reduce((all, str) => {
    return all + String(vals.shift()) + str
  })

  return <InjectedScript code={code} />
}

class InjectedScript extends Component {
  componentDidMount() {
    this.injectScript()
  }

  injectScript() {
    const { code, src } = this.props
    const script = document.createElement('script')
    if (code) {
      script.text = code
    }
    if (src) {
      script.src = src
    }
    document.body.appendChild(script)
  }

  render() {
    return <span />
  }
}


////////////////////////////////////////////////


export const Retain = ({ email }) => script`
  (function(i,s,o,g,r,a,m){i['ProfitWellObject']=r;i[r]=i[r]||function(){  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);  })(window,document,'script','https://dna8twue3dlxq.cloudfront.net/js/profitwell.js','profitwell');

  profitwell('auth_token', '43be4f7183e3a743d28b4cf8b9614b4f');
  profitwell('user_email', '${email}');
`

export const ZapierTemplate = ({ id="zapier_widget" }) => (
  <div>
    <div id={id} />
    <InjectedScript src={`https://zapier.com/apps/embed/widget.js?services=showcase-idx&limit=4&html_id=${id}`} />
  </div>
)


// WEBPACK FOOTER //
// client/components/injected_scripts.js